<template>
  <div>
    <el-cascader style="width: 100%;" placeholder="请选择地址" v-model="value" :options="citylist"
      @change="cityhandleChange"></el-cascader>
  </div>
</template>

<script>
export default {
  props: {
    cityvalue: {
      type: Array,
      default: () => []
    },
  },

  data() {
    return {
      value: []
    };
  },
  watch: {
    cityvalue: {
      handler(val) {
        if (val.length > 0) {
          this.value = val;
          return
        }
        this.value = [];
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    citylist() {
      return this.$store.state.citylist
    }
  },
  methods: {
    cityhandleChange(e) {
      this.$emit('cityhandleChange', e);
    }
  }
};
</script>

<style lang="scss" scoped></style>